/**
 * Capitalize the first letter of a string.
 *
 * @note use the CSS solution provided the theme.mixins above this solution if possible.
 */
const capitalizeFirstLetter = (s: string) =>
  s.replace(/./, c => c.toUpperCase())

export default capitalizeFirstLetter
